module.exports = __webpack_public_path__ + "img/historia_3-4_2304.5bc3c925.jpg";